import { GraphQLClient } from 'graphql-request';

const graphql = {
  sendContactMessage: function (fields) {
    console.log('fields', fields);
    const query = `
      mutation ContactFormMutation($email: String!, $name: String!, $subject:String!, $message:String!) {
        contactFormMutation(
        input: {email: $email, name: $name, subject: $subject, message: $message}) {
          success
        }
      }
    `;
    let endpoint = process.env['REACT_APP_GRAPHQL_URL_' + process.env.REACT_APP_ENV.toUpperCase()];
    const client = new GraphQLClient(endpoint, {mode: 'cors'});
    return client.request(query, fields);
  },
  signupToMailingList: function (fields) {
    console.log('fields', fields);
    const query = `
      mutation MailingListMutation($email: String!, $name: String!) {
        mailingListMutation(
        input: {email: $email, name: $name}) {
          success
        }
      }
    `;
    let endpoint = process.env['REACT_APP_GRAPHQL_URL_' + process.env.REACT_APP_ENV.toUpperCase()];
    const client = new GraphQLClient(endpoint, {mode: 'cors'});
    return client.request(query, fields);
  },
  getCourses: function () {
    const query = `{
      courses {
        id
        title
        description
        type
        category
        level
        slug
        aims
        requirements
        testimonials
        noOfClassMates
        fullSpec
        specSummary
        salesSiteVideoEmbedCode
        salesSiteSampleVideoEmbedCode
        tutorialLengthMinutes
        courseOptions {
          price
          instalmentPrice
          instalmentDurationMonths
          courseDurationWeeks
        }
      }
    }`;
    const envar = 'REACT_APP_GRAPHQL_URL_' + process.env.REACT_APP_ENV.toUpperCase();
    // console.log('envar', envar);
    // let endpoint = process.env['REACT_APP_GRAPHQL_URL_' + process.env.REACT_APP_ENV.toUpperCase()];
    // let endpoint = process.env['REACT_APP_GRAPHQL_URL_DEVELOPMENT'];
    let endpoint = process.env[envar];
    // console.log('endpoint', endpoint);
    const client = new GraphQLClient(endpoint, {mode: 'cors'});
    return client.request(query);
  }
};

export default graphql;



// WEBPACK FOOTER //
// ./src/helpers/graphql.js